// PIN service for presentation access
export interface PinStatus {
  authorized: boolean;
}

class PinService {
  private baseUrl = '/api/pin';

  /**
   * Verify presentation PIN
   */
  async verifyPin(pin: string): Promise<{ message: string }> {
    const response = await fetch(`${this.baseUrl}/verify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pin }),
      credentials: 'include',
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to verify PIN');
    }

    return response.json();
  }

  /**
   * Check if PIN is configured
   */
  async isConfigured(): Promise<boolean> {
    try {
      const response = await fetch(`${this.baseUrl}/is-configured`);
      const data = await response.json();
      return data.configured;
    } catch (error) {
      return false;
    }
  }

  /**
   * Check current presentation access status
   */
  async getStatus(): Promise<PinStatus> {
    try {
      const response = await fetch(`${this.baseUrl}/status`, {
        credentials: 'include',
      });

      if (!response.ok) {
        return { authorized: false };
      }

      return response.json();
    } catch (error) {
      return { authorized: false };
    }
  }

  /**
   * Set presentation PIN (Admin only)
   */
  async setPin(pin: string, confirmPin: string): Promise<{ message: string }> {
    const response = await fetch(`${this.baseUrl}/set`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pin, confirmPin }),
      credentials: 'include',
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to set PIN');
    }

    return response.json();
  }
}

export const pinService = new PinService();
